import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import React from "react";

/* eslint-disable no-underscore-dangle */

/* global _NW_APP_BUILD_ */
// Previously, all of these imports were inline `require(...)` statements.
// However, that didn't let us take advantage of tree shaking via ES Modules
// (at least on Webpack 4). Dead code elimination should ensure that these
// packages don't end up being used in the final bundle if they're unneeded.

/* eslint-disable import/no-unresolved -- these are aliases */
import { ApolloProvider } from 'nw-app-build/alias-to/@nerdwallet/apollo';
import getApolloClient from 'nw-app-build/alias-to/@nerdwallet/apollo/client';
import AccessibilitySSRProvider from 'nw-app-build/alias-to/@nerdwallet/react-accessibility-provider';
import { StructuredContentProvider, createClient } from 'nw-app-build/alias-to/@nerdwallet/structured-content';
import apolloOptions from 'nw-app-build/alias-to/apolloOptionsPath';
import configureStore from 'nw-app-build/alias-to/configureStorePath';
import { AppContainer } from 'nw-app-build/alias-to/react-hot-loader';
import { Provider as ReduxProvider } from 'nw-app-build/alias-to/react-redux';
import ReactDOM from 'react-dom';
import appConfig from '@nerdwallet/app-config';
/* eslint-enable import/no-unresolved */

import isValidHostname from './isValidHostname';

var mark = function mark(name) {
  var _window$performance;

  (_window$performance = window.performance) === null || _window$performance === void 0 ? void 0 : _window$performance.mark(name);
}; // Mark the time at which the app's JS has been downloaded, parsed and begun to be evaluated


mark('nw-evaluate-app-javascript');

var measure = function measure(name, start, finish) {
  var _window$performance2;

  (_window$performance2 = window.performance) === null || _window$performance2 === void 0 ? void 0 : _window$performance2.measure(name, start, finish);
};

var init = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var store, apolloClient, hot, redux, structuredContent, apollo, accessibility, render, rootEl, initialState;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(isValidHostname(window.location.hostname, appConfig.NERDWALLET_HOSTNAMES) === false)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            if (!_NW_APP_BUILD_.__APOLLO__) {
              _context.next = 6;
              break;
            }

            _context.next = 5;
            return getApolloClient(apolloOptions);

          case 5:
            apolloClient = _context.sent;

          case 6:
            /**
             * This function will wrap the entry component with react hot reload
             */
            hot = function hot(children) {
              if (!_NW_APP_BUILD_.__HOT__) {
                return children;
              }

              return /*#__PURE__*/React.createElement(AppContainer, null, children);
            };
            /**
             * This function will wrap the entry component with react-redux's <Provider />
             */


            redux = function redux(children) {
              if (!_NW_APP_BUILD_.__REDUX__) {
                return children;
              }

              return /*#__PURE__*/React.createElement(ReduxProvider, {
                store: store
              }, children);
            };
            /**
             * This function will wrap the entry component with @nerdwallet/structured-content's <StructuredContentProvider />
             */


            structuredContent = function structuredContent(children) {
              if (!_NW_APP_BUILD_.__STRUCTURED_CONTENT__) {
                return children;
              } // sanity check that `@nerdwallet/structured-content` was available


              if (!StructuredContentProvider || !createClient) {
                throw new Error("@nerdwallet/structured-content dependency could not be loaded. Is it installed in your app's package.json file?");
              } // bootstrap StructuredContentProvider using the data supplied by nw-app-module's SSR render.


              var scClient = createClient({
                apolloClient: apolloClient,
                isomorphicState: window.__STRUCTURED_CONTENT_STATE__ // hardcoded as the same string in nw-app-module/server/render

              });
              return /*#__PURE__*/React.createElement(StructuredContentProvider, {
                client: scClient
              }, children);
            };
            /**
             * This function will wrap the entry component with apollo's <Provider /> and instantiate an apollo client
             */


            apollo = function apollo(children) {
              if (!_NW_APP_BUILD_.__APOLLO__) {
                return children;
              }

              return /*#__PURE__*/React.createElement(ApolloProvider, {
                client: apolloClient
              }, children);
            };
            /**
             * This function will wrap the entry component with @nerdwallet/react-accessibility-provider <SSRProvider />
             * This allows for autogenerated deterministic IDs from nw react component libraries
             */


            accessibility = function accessibility(children) {
              return /*#__PURE__*/React.createElement(AccessibilitySSRProvider, null, children);
            };
            /**
             * The render function -- bootstraps react with the requested wrappers into the DOM node specified in `reactRoot`
             */


            render = function render(rootEl) {
              // For hot module replacement to work, we need to `require()` entry point
              // here instead of with an `import` at the top of this file.
              // eslint-disable-next-line import/no-unresolved
              var App = require('nw-app-build/alias-to/browserEntryPath');

              App = App.default || App;
              var renderApp;

              if (_NW_APP_BUILD_.__SSR__) {
                // If SSR is enabled, try to hydrate if we're running on a version of
                // react-dom that supports it (>=16)
                renderApp = ReactDOM.hydrate || ReactDOM.render;
              } else {
                // If SSR is disabled, use `render` since there won't be a server-rendered
                // app to hydrate
                renderApp = ReactDOM.render;
              }

              renderApp(hot(accessibility(structuredContent(apollo(redux( /*#__PURE__*/React.createElement(App, {
                store: store
              })))))), rootEl);
            };

            rootEl = document.getElementById(_NW_APP_BUILD_.__REACT_ROOT__);

            if (_NW_APP_BUILD_.__REDUX__) {
              /**
               * Bootstrap redux store by looking for store state in the window object.
               * The reason this is within init is so that the store can be passed into
               * the render function and to the entry component in particular.
               */
              initialState = window[_NW_APP_BUILD_.__REDUX_STORE_KEY__]; // on the server, the 2nd and third params for configureStore are the express request and response

              store = (configureStore.default || configureStore)(initialState, undefined, undefined, {
                apolloClient: apolloClient
              });
            } // Mark the time prior to react render


            mark('nw-initial-react-render-start'); // Render it!

            render(rootEl); // Mark the time after react render. The app should be responsive after this

            mark('nw-initial-react-render-finish'); // Measure the delta between react render start and finish

            measure('nw-initial-react-render-duration', 'nw-initial-react-render-start', 'nw-initial-react-render-finish');

            if (_NW_APP_BUILD_.__HOT__) {
              module.hot.accept(require.resolve('nw-app-build/alias-to/browserEntryPath'), function () {
                render(rootEl);
              });
              /**
               * Only handle redux hot reloading if `redux` is enabled
               */

              if (_NW_APP_BUILD_.__REDUX__) {
                module.hot.accept(require.resolve('nw-app-build/alias-to/configureStorePath'), function () {
                  // We specifically need to use `require()` instead of `import` for
                  // hot module replacement to work correctly.
                  // eslint-disable-next-line import/no-unresolved
                  var newReducers = require('nw-app-build/alias-to/reducersPath');

                  store.replaceReducer(newReducers.default || newReducers);
                });
              }
            }

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function init() {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Only initialize the app after dom content has been loaded
 */


if (document.readyState === 'interactive' || document.readyState === 'complete') {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init);
}